import React, { useState, useEffect } from "react";
import "./CommunitySection4.scss";
import useTranslationCustom from "../../assets/image/community-section-1/useTranslationCustom";
import useScrollAnimation from "../../module/animation/useScrollAnimation";
import toast from "react-hot-toast";
import AWS from "aws-sdk";
const accessKeyId = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
const secretAccessKey = process.env.REACT_APP_AWS_SECRET_ACCESS_KEY;
const region = process.env.REACT_APP_AWS_REGION;
const companyEmail = process.env.REACT_APP_COMPANY_EMAIL;

function CommunitySection4() {
  const { t } = useTranslationCustom({
    prefix: "section_4",
    nameSpace: "community",
  });
  useEffect(() => {
    AWS.config.update({
      accessKeyId,
      secretAccessKey,
      region,
    });
  }, []);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const inputData = [
    {
      title: t("inputs.name.title"),
      placeHolder: t("inputs.name.placeholder"),
      isLast: false,
      value: name,
      onChange: handleNameChange,
    },
    {
      title: t("inputs.email.title"),
      placeHolder: t("inputs.email.placeholder"),
      isLast: false,
      value: email,
      onChange: handleEmailChange,
    },
    {
      title: t("inputs.message.title"),
      placeHolder: t("inputs.message.placeholder"),
      isLast: true,
      value: message,
      onChange: handleMessageChange,
    },
  ];
  const emailSubmit = async () => {
    if (name && email && message) {
      try {
        const lambda = new AWS.Lambda({
          region: region,
        });
        const params = {
          FunctionName: "cs_sendMail_viaHomepage",
          Payload: JSON.stringify({
            from: companyEmail,
            to: companyEmail,
            subject: `An email from a ${name} has arrived on the EQBR website.`,
            body: `User's email address is ${email}. message: ${message}`,
          }),
        };
        lambda.invoke(params, function (error, data) {
          if (data.StatusCode !== 200) {
            toast.error(
              "There was an error sending the email. Please try again later."
            );
          } else {
            toast.success("Email sent successfully!");
            setName("");
            setEmail("");
            setMessage("");
          }
        });
      } catch (error) {
        toast.error(
          "There was an error sending the email. Please try again later."
        );
      }
    } else if (!name) {
      toast.error("Please enter name.");
    } else if (!email) {
      toast.error("Please enter email.");
    } else if (!message) {
      toast.error("Please enter message.");
    }
  };

  useScrollAnimation(["community-section-4"]);
  return (
    <div
      id="Email"
      className={"community-section-4 container FLEX_COLUMN_ALIGN_CENTER"}
    >
      <div className="community-section-4-title">{t("title")}</div>

      <div className="community-section-4-input">
        {inputData.map((el, index) => {
          return (
            <div className="community-section-4-input-wrapper" key={index}>
              <div className="community-section-4-input-wrapper-title">
                {el.title}
              </div>
              <textarea
                className={
                  el.isLast
                    ? "community-section-4-input-wrapper-input-last"
                    : "community-section-4-input-wrapper-input"
                }
                name={el.title.toLowerCase().replace(" ", "_")}
                placeholder={el.placeHolder}
                value={el.value}
                onChange={el.onChange}
              />
            </div>
          );
        })}
      </div>

      <div
        className="community-section-4-btn FLEX_CENTER"
        onClick={() => emailSubmit()}
      >
        {t("button")}
      </div>
    </div>
  );
}

export default CommunitySection4;
